"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _DateOutput = _interopRequireDefault(require("../DateOutput/DateOutput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Timeline allow to display a list of events in chronological order.
 */
const Timeline = _ref => {
  let {
    data,
    className,
    position,
    shape,
    title,
    ...attributes
  } = _ref;
  const classes = (0, _clsx.default)('uk-timeline', "uk-timeline__" + position, className);
  return /*#__PURE__*/_react.default.createElement("section", _extends({
    className: classes
  }, attributes), data.map(item => /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-timeline__card",
    key: item.id
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "uk-timeline__shape uk-timeline--" + shape
  }, /*#__PURE__*/_react.default.createElement("time", null, /*#__PURE__*/_react.default.createElement(_DateOutput.default, {
    date: item.pathDate,
    dateStyle: "hide",
    timeStyle: "short"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-timeline__content"
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "uk-timeline__title"
  }, item == null ? void 0 : item.title), /*#__PURE__*/_react.default.createElement("a", {
    href: item.path,
    className: "uk-timeline__text"
  }, item.path)))));
};
Timeline.propTypes = {
  /**
   * Array of timelines
   */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /**
   * Display title for each timeline
   */
  title: _propTypes.default.bool,
  /**
   * Position of the timeline
   */
  position: _propTypes.default.oneOf(['left', 'right', 'leftAndRight']),
  /**
   * Type of the shape
   */
  shape: _propTypes.default.oneOf(['circle', 'square'])
};
Timeline.defaultProps = {
  data: [],
  title: false,
  position: 'leftAndRight',
  shape: 'circle'
};
var _default = exports.default = Timeline;